import { FooterSchema } from './Footer.styles';

export const footerStyles: FooterSchema = {
  copyrightContainer: {
    px: 1,
    fontFamily: 'accent',
  },
  footer: {
    pt: 4,
    bg: 'transparent',
    bgSize: 'cover',
    bgPos: 'bottom',
    color: 'white',
  },
  stackGap: '1',
  footerBar: {
    display: 'flex',
    flexDir: ['column', null, 'row'],
    borderRadius: 'md',
    alignItems: 'center',
    justifyContent: ['center', null, 'unset'],
  },
  footerLink: {
    color: 'alpha.300',
    textTransform: 'lowercase',
    cursor: 'pointer',
    display: 'inline-block',
    mt: '0',
    whiteSpace: 'nowrap',
    fontWeight: 'bold',
    fontSize: 'xs',
  },
  footerLinkService: {
    color: 'alpha.300',
  },
  footerLinkTel: {
    color: 'white',
    textTransform: 'lowercase',
    cursor: 'pointer',
    display: 'inline-block',
    mt: '0',
    whiteSpace: 'nowrap',
  },
  footerMobile: {
    borderRadius: 'lg',
    w: '130px',
    cursor: 'pointer',
    boxShadow: '0px 2px 7px rgba(0, 0, 0, 0.3)',
  },
  customFooterLink: {
    cursor: 'pointer',
    display: 'inline-block',
    mt: '0',
    whiteSpace: 'nowrap',
    fontSize: 'xs',
    color: 'white',
    textTransform: 'capitalize',
    h: 'unset',
    mb: '1px',
  },
  footerLinks: {
    ml: ['unset', null, 'auto'],
    pb: '0',
    alignItems: 'center',
    justifyContent: ['space-around', null, 'unset'],
    color: 'white',
    fontWeight: 'medium',
    flexDir: ['row', null, 'unset'],
    display: 'inline-flex',
    mt: ['18px', null, '0'],
    gap: '1',
  },
  footerContentContainer: {
    px: [3, null, 1],
    gap: '6',
    mb: 'unset',
    bg: [null, null, 'transparent'],
    justifyContent: 'space-between',
    sx: {
      '&': {
        flexDirection: ['column-reverse', null, 'column'],
      },
    },
    fontFamily: 'accent',
  },
  nav: {
    fontSize: 'sm',
    minW: [null, null, '370px'],
    mt: ['2', 'unset'],
    display: ['flex', 'grid'],
    gridTemplateColumns: '1fr 1fr 1fr',
    gridTemplateRows: 'auto',
    columnGap: '10',
    rowGap: '2',
    alignItems: ['center', 'end'],
    gridTemplateAreas: `
        ". ."
      `,
    sx: {
      '> a': {
        color: 'inherit',
        h: 'unset',
        fontWeight: 'medium',
        fontSize: 'xs',
      },
      '> button': {
        h: 'unset',
        fontWeight: 'medium',
        fontSize: 'xs',
      },
    },
  },
  LinkText: {
    fontWeight: 'medium',
    fontSize: 'xs',
  },
  blurb: {
    flex: 'unset',
    textAlign: ['center', 'left'],
    color: 'white',
    fontSize: 'xs',
    width: 'unset',
    mb: '0',
    ml: [null, '0'],
    mr: [null, null, '0'],
    pr: '0',
    sx: {
      'p:first-of-type': {
        mt: '0',
      },
    },
  },
  blurbHeading: {
    ml: 'unset',
    mt: 'unset',
    color: 'whiteAlpha.700',
    fontFamily: 'accent',
  },
  blurbHeadingAge: {
    color: 'white',
    borderColor: 'blackAlpha.50',
    border: '2px',
    mb: '2',
    boxSize: '8',
    fontSize: 'xs',
    fontFamily: 'accent',
  },
  blurbHeadingThink: {
    color: 'white',
    fontSize: 'xs',
    fontWeight: 'bold',
    mb: '3',
  },
  blurbContent: {
    ml: 'unset',
    px: ['2', null, '0'],
    fontSize: ['xs', null, null, 'xs'],
    lineHeight: 'tall',
  },
  copyright: {
    color: 'white',
    textAlign: ['center', 'left'],
    mb: ['2', 'unset'],
    px: ['8', 'unset'],
    py: '0',
    fontWeight: 'medium',
  },
  container: {
    bg: 'transparent',
    gap: '4',
    display: 'flex',
    flexDir: 'column',
    sx: {
      '&': {
        px: 'unset',
      },
    },
  },
  emailUs: {
    px: 1,
    fontSize: 'xs',
    fontWeight: 'bold',
    mb: '0',
    fontFamily: 'accent',
  },
  quickLinks: {
    textAlign: ['center', 'left'],
    color: 'alpha.300',
    textTransform: 'uppercase',
    fontSize: 'base',
    fontWeight: 'bold',
    pb: '0.5',
  },
  weAcceptBox: {
    mb: '0',
  },
  weAccept: {
    color: 'alpha.300',
    textTransform: 'uppercase',
    fontSize: 'base',
    fontWeight: 'bold',
  },
  imageWrapper: {
    gap: '0',
  },
  partnerWrapper: {
    mr: '1',
    boxShadow: '0px 2px 4px 1px rgba(0, 0, 0, 0.30)',
  },
  ourPartners: {
    color: 'alpha.300',
    textTransform: 'uppercase',
    fontSize: 'base',
    fontWeight: 'bold',
  },
};
